import { ComponentPropsWithoutRef } from 'react';
import { RoundelWrapper } from './styles';

export const Roundel = ({ children, ...otherProps }: ComponentPropsWithoutRef<'div'>) => {
    return <RoundelWrapper {...otherProps}>{children}</RoundelWrapper>;
};
